import state from './moduleVoyageHistoryState.js'
import mutations from './moduleVoyageHistoryMutations.js'
import actions from './moduleVoyageHistoryActions.js'
import getters from './moduleVoyageHistoryGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};